import Alpine from "alpinejs";
import wpFeSanitizeTitle from "../utilities/sanitize-title";



const initScrollSpy = function() {
  Alpine.store("toggleButton", {
    on: false,
    toggle() {
      this.on = !this.on;
    },
  });

  const faqSinglePage = document.querySelector('.faq-contents');
  const tableOfContents = document.getElementById('faq-toc');
  const tableOfContents__Nav = document.querySelector('.scrollspy__menu');
  const tableOfContents__NavIcon = document.querySelector('.scrollspy__arrowicon');

  function openDropdown() {
    if (window.innerWidth < 1024) tableOfContents__Nav.style.maxHeight = `${tableOfContents__Nav.scrollHeight}px`
    tableOfContents__NavIcon.style.setProperty('--tw-rotate', '180deg');
  }

  function closeDropdown() {
    if (window.innerWidth < 1024) tableOfContents__Nav.style.maxHeight = 0
    tableOfContents__NavIcon.style.setProperty('--tw-rotate', '0deg');
  }

  if (faqSinglePage) {
    const menuItems = faqSinglePage.querySelectorAll(".scrollspy__menu a"); //use .scrollspy__menu for parent element of list menu
    const sectionH2 = faqSinglePage.querySelectorAll("h2");
    const sectionH3 = faqSinglePage.querySelectorAll("h3");
    let sections = {};
    let i = 0;
  
    if (sectionH2){
      sectionH2.forEach((elm, index) => {  
        if (elm) elm.setAttribute('id', wpFeSanitizeTitle(elm.innerHTML));
      });
    }
  
    if (sectionH3){
      sectionH3.forEach((elm, index) => {  
        if (elm) elm.setAttribute('id', wpFeSanitizeTitle(elm.innerHTML));
      });
    }
  
    /**
     * 102px is the offset top container on mobile
     * 72px from the sticky button element
     * 30px from the fade element at the bottom of the button
     */
    let offsetTopContainer = 102+96;
    if (window.matchMedia("(min-width: 420px)").matches) {
      offsetTopContainer = 102+78;
    }
    
    if (window.matchMedia("(min-width: 1024px)").matches) {
      /**
       * 40px is the offset top container on larger than 1024px width
       * 32px is the offset top of the sidebar
       * 8px is the padding top of the first menu on the sidebar
       * we don't need the fade element as the desktop it's being hidden
       */
      offsetTopContainer = 40+56;
    }

    if (sectionH2){
      Array.prototype.forEach.call(sectionH2, function (e) {
        sections[e.id] = e.offsetTop;
      });
    }

    // if (sectionH3){
    //   Array.prototype.forEach.call(sectionH3, function (e) {
    //     sections[e.id] = e.offsetTop;
    //   });
    // }
  
    menuItems.forEach((menu) => {
      menu.addEventListener("click", (e) => {
        e.preventDefault();
  
        const elm = menu.getAttribute("href");
        const elmTop = window.acf ? document.querySelector(`${elm}`).offsetParent.offsetTop : document.querySelector(`${elm}`).offsetTop
        const offsetTop = elmTop - offsetTopContainer;
          
        if (window.acf)  {
          document.querySelector('.interface-navigable-region.interface-interface-skeleton__content').scrollTop = offsetTop
        } else {
          window.scrollTo({
            top: offsetTop,
            left: 0,
            behavior: "smooth",
          });
        }
  
        Alpine.store("toggleButton").toggle();

        closeDropdown();
      });
    });
  
    document.addEventListener('scroll', function() {
      let scrollPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
  
      for (i in sections) {
        if (i && sections[i] <= scrollPosition + offsetTopContainer) {
          menuItems.forEach((menu) => {
            menu.classList.remove('is-active');
          });
  
          document
            .querySelector(`.scrollspy__menu a[href="#${i}"]`)
            .classList.add('is-active');
        }
      }
    }, true)
  }

  if (tableOfContents) {
    tableOfContents.addEventListener('click', () => {
      Alpine.store("toggleButton").toggle();
  
      if (Alpine.store("toggleButton").on) openDropdown()
      else closeDropdown()
    })
  }
}

if (window.acf) {
  const allowedBlocks = [
      "faq-single-page-block",
      "faq-navs-block",
      "faq-contents-block",
      "faq-item-content-block"
  ];
  // register block to ACF global object
  allowedBlocks.forEach(block => {
    window.acf.addAction( `render_block_preview/type=${block}`, initScrollSpy );
  });

} else {
  initScrollSpy();
}